import React, { useState } from 'react';
import axios from 'axios';

const WebsiteUrl = () => {
    const [url, setUrl] = useState('');
    const [response, setResponse] = useState('');

    const handleInputChange = (e) => {
        setUrl(e.target.value);
    };

    const handleButtonClick = async () => {
        try {
            // Call the API with the input value
            const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify/get-company-data`, {
                email: url
            }, {
                headers: {
                    "Authorization":"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMDAwMCwiaWF0IjoxNzI1NTIwNDQ3LCJleHAiOjE3MjgxMTI0NDd9.8c5iFAhJmeO0ayWxjW3ElaycmgA2XkNxV26aDqp5Oxw",
                    "x-api-key":"secret_api_key_123456",
                    "Content-Type":"application/json"
                }
            });
            console.log("result.data",result.data)
            setResponse(result.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setResponse('Failed to fetch data.');
        }
    };

    return (
        <div style={styles.container}>
            <input 
                type="text" 
                value={url} 
                onChange={handleInputChange} 
                placeholder="Enter Email"
                style={styles.input} 
            />
            <button onClick={handleButtonClick} style={styles.button}>
                Submit
            </button>

             {/* Display the response */}
        <div style={styles.response}>
            {response && response.base64Logo && (
                <div>
                    <p>Response:</p>
                    <img src={response.base64Logo} alt="Response Image" style={styles.image} />
                </div>
            )}
             {response && response.logoUrl && (
                <div>
                    <p>Response:</p>
                    <img src={response.logoUrl} alt="Response Image" style={styles.image} />
                </div>
            )}
        </div>
        </div>
    );
};

// CSS styles
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: 'Arial, sans-serif'
    },
    input: {
        padding: '10px',
        marginBottom: '10px',
        width: '300px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        fontSize: '16px'
    },
    button: {
        padding: '10px 20px',
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px'
    },
    response: {
        marginTop: '20px',
        padding: '10px',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#f4f4f4',
        borderRadius: '5px',
        border: '1px solid #ddd',
        fontSize: '16px'
    }
};

export default WebsiteUrl;
